<template>
  <div class="placeholder-container"
    :class="{ 'error': errorInput, 'bigInp_centered': inputStyle === 'big', 'input-medium': inputSize === 'medium' }">
    <input
      :value="fValue"
      type="text"
      placeholder=" "
      :inputmode="_inputMode"
      :maxlength="_maxLength"
      v-mask="mask"
      :name="name"
      :autocomplete="autocomplete || 'on' "
      class="mainInp"
      :class="{ 'acceptInp': acceptInput, 'bigMainInp': inputStyle === 'big', 'uppercase': !!inputUpper }"
      @focus="onFocus"
      @blur="onBlur"
      @change="onInput"
      @input="onInput"
      @click="$emit('click')"
      ref="input">
    <label :for="name">{{ placeholder }}</label>
    <div  @mousedown.prevent @click="clearInput">
      <BaseClearInput
        v-if="focused && isValue"
        tabindex="-1"
        :class="{ 'bigClearInp': inputStyle === 'big' }" />
    </div>
    <BaseInputError :error="errorInput">
      <slot name="empty-input-error" v-if="!value">
        {{ requireErrorMessage }}
      </slot>
      <slot class="error" name="invalid-input-error" v-if="value">
        {{ invalidErrorMessage }}
      </slot>
    </BaseInputError>
  </div>
</template>

<script>
import BaseClearInput from './BaseClearInput.vue'
import BaseInputError from './BaseInputError.vue'

export default {
  props: [
    'validation',
    'placeholder',
    'value',
    'name',
    'mask',
    'inputStyle',
    'inputUpper',
    'inputSize',
    'inputMode',
    'thousandSeparator',
    'autocomplete',
    'maxlength',
    'trim'
  ],
  components: {
    BaseClearInput,
    BaseInputError
  },
  data () {
    return {
      focused: false
    }
  },
  computed: {
    fValue: {
      get () {
        if (this.value !== '' && this.thousandSeparator) {
          return this.formatThousandSep(this.value)
        }
        return this.value
      }
    },
    errorInput () {
      return this.validation?.$dirty && this.validation?.$invalid
    },
    acceptInput () {
      if (!this.validation) return false
      return !this.validation?.$invalid
    },
    _inputMode () {
      return this.inputMode || 'text'
    },
    _maxLength () {
      return this.maxlength || ''
    },
    isValue () {
      return this.fValue ? this.fValue.length : 0
    },
    requireErrorMessage () {
      return this.$t('qic_error_empty_input')
    },
    invalidErrorMessage () {
      return this.$t('qic_error_invalid_input')
    }
  },
  methods: {
    formatThousandSep (num) {
      if (!num) return ''

      let parsedNumber = Number(num
        .toString()
        .replace(/[A-Za-z]|[\u0621-\u064a]/g, ''))

      if (isNaN(parsedNumber)) parsedNumber = 0

      const formattedNumber = parsedNumber.toString()
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')

      return formattedNumber
    },
    parseThousandSep (text) {
      return text.replace(/,/g, '')
    },
    onInput (event) {
      if (this.trim) {
        event.target.value = event.target.value.trim()
      }

      const inputValue = event.target.value
      const cursorPosition = event.target.selectionStart
      const oldFormattedValue = this.fValue || ''

      const value = this.thousandSeparator
        ? this.parseThousandSep(inputValue)
        : inputValue

      this.$emit('input', value)

      this.$nextTick(() => {
        const newFormattedValue = this.fValue || ''
        const addedCommas = (newFormattedValue.match(/,/g) || []).length - (oldFormattedValue.match(/,/g) || []).length
        this.$refs.input.selectionStart = cursorPosition + addedCommas
        this.$refs.input.selectionEnd = cursorPosition + addedCommas
      })

      if (this.validation) {
        this.validation.$reset()
      }
    },

    clearInput () {
      this.$refs.input.value = ''
      this.$emit('input', '')
    },
    onFocus () {
      this.focused = true
      this.$emit('focus')
    },
    onBlur (event) {
      this.focused = false
      this.$emit('blur', event)
    }
  }
}
</script>
